import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { GridItem } from "./GridItem";
import "./sass/grid.css";


export const Grid = ({ columnas, datas, classNameRow,
    id, keyTranslate, tipoTable, handleDblClick,
    checkRows, topPage, columnasRender, idRefresh, classTable, classHead,handleShow
    , emptyMsg, valueEmptyMsg
    }) => {

    if(idRefresh === undefined || idRefresh === null) {
        idRefresh = "";
    }

    const [objData, setObjData] = useState(datas ? datas : {});

    const idTable = id ? id : (`tableData${new Date().getTime()}`);

 
    topPage = topPage && topPage > 0 ? topPage : 20;


    useEffect(() => {
        setObjData(datas);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objData, datas]);


    const getColumnasLabel = () => {
        const labels = new Array(0);
        if (columnasRender) {
            for (let r = 0; r < columnasRender.length; r++) {
                if (columnasRender[r]?.label) {
                    labels.push(columnasRender[r].label);
                }
            }
        }
        return labels;
    };

    const columnasHeader = columnasRender && columnasRender.length > 0 ? getColumnasLabel() : columnas;

    return (
        <>
            <div className="gridTable orders">
                
                <table id={id ? id : idTable} className={classTable}>
                    <thead className={classHead}>
                        <tr>
                            {
                                columnasHeader.map((columna, index) => {
                                    let classHeaderCol = "";
                                    if (columnasRender) {
                                        for (let ind = 0; ind <= columnasRender.length; ind++) {
                                            if (columnasRender[ind].label === columna) {
                                                classHeaderCol = columnasRender[ind].className;
                                                
                                                break;
                                            }
                                        }
                                    }

                                    return <th key={index + 1} scope="col" className={(columna === "check" ? "select " : "") + classHeaderCol}>
                                        { <FormattedMessage id={`${keyTranslate}.${columna}`} defaultMessage={""} />}

                                    </th>;
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            objData && objData.length > 0 ?

                                (

                                    
                                        objData.map((columna, indexC) => {

                                            return <GridItem key={`g${indexC}`}
                                                
                                                classNameRow={classNameRow}
                                                tipoTable={tipoTable}
                                                columna={columna} indexC={indexC}
                                                handleDblClick={handleDblClick}
                                                checkRows={checkRows}
                                                columnasRender={columnasRender}
                                                handleShow={handleShow}
                                                />
                                        })
                                        
                        )
                        :
                        (
                            <tr>
                                <td className="table-text-center forceCenter" colSpan={columnasHeader? columnasHeader.length : 1} >
                                    {emptyMsg ? 
                                    <FormattedMessage id={`${keyTranslate}.${emptyMsg}`} defaultMessage={emptyMsg} values={valueEmptyMsg}/>
                                    : 
                                    <FormattedMessage id={"general.Records not found"} defaultMessage={"Records not found"} />
                                    }
                                </td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </div>
        </>

    );
}
